import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { AppConfig } from 'src/app/config';
import { moduli } from '../../config';
import { PlanskaKalkulacijaService } from './planska-kalkulacija.service';

@Component({
  selector: 'app-planska-kalkulacija',
  templateUrl: './planska-kalkulacija.component.html',
  styleUrls: ['./planska-kalkulacija.component.scss'],
  providers: [PlanskaKalkulacijaService],
})
export class PlanskaKalkulacijaComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;

  idPlan: any;
  token: any;
  brojTura: number = 1;
  cijenaStruja: number = 0;
  cijenaPlin: number = 0;
  cijenaVoda: number = 0;
  cijenaOTP: number = 0;
  plan = {
    idKalkulacija: '',
    datum: '',
    sifra: '',
    proizvod: '',
    idProizvod: '',
    linija: '',
    kolicina: '',
    nedjelja: '',
    petak: '',
    linijaId: '',
    smjenaId: '',
    rnId: '',
    rnBroj: '',
  };
  procesi: any;
  djelatnici: any;
  strojevi: any;
  normativi: any;
  isLoading: boolean = true;
  tabs: any;
  prikaziTablicuProcesi: boolean = true;
  prikaziTablicuStrojevi: boolean = false;
  prikaziTablicuNormativi: boolean = false;
  prikaziTablicuDjelatnici: boolean = false;
  prikaziTablicuOTP: boolean = false;
  prikaziTablicuNapomenaiSlike: boolean = false;
  napomena_komentar: any;
  filee: any;
  sviDokumenti: any = [];
  upload_URL: any = AppConfig.ipAddress + 'spremi_dokument';
  URL: any = AppConfig.IPfile;
  maskRules: any;
  oznacenRed: number;
  dodajDjelatnikaPopupVisible = false;
  sviDjelatnici: any;
  sviProcesi: any;
  sviStrojevi: any;
  odabraniDjelatnik: any;
  odabraniProces: any;
  pocetak: any;
  kraj: any;
  pocetakSlanje: any;
  krajSlanje: any;
  dodajProcesPopupVisible = false;
  vtoum: number;
  vtcpum: number;
  vrrum: number;
  brno: number;
  crrum: number;
  odabraniStroj: any;
  stroj = {
    amortizacija: null,
    potrosnjaStruje: null,
    struja: null,
    potrosnjaPlina: null,
    plin: null,
    potrosnjaVode: null,
    voda: null,
    ulaznaFaktura: null,
  };
  dodajStrojPopupVisible = false;
  dodajOTPPopupVisible = false;
  sumaProcesi: any;
  sumaAmortizacija: any;
  sumaStruja: any;
  sumaPlin: any;
  sumaVoda: any;
  sumaOTP: any;
  napomena: string;
  ostaliTroskovi: any;
  nazivDodatka: string;
  cijenaDodatka: number;
  sumaProcesiKn: number;
  sumaAmortizacijaKn: number;
  sumaStrujaKn: number;
  sumaPlinKn: number;
  sumaVodaKn: number;
  sumaOtpKn: number;
  sumaUkupno: any;
  sumaKomad: any;
  sumaNormativi: any;
  sumaNormativiKn: number;
  troskovnik: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private service: PlanskaKalkulacijaService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.idPlan = parseInt(this.route.snapshot.params['id']);
    this.token = sessionStorage.getItem('token');
    this.service
      .dohvatiPlan({ idplanproizvodnje: this.idPlan })
      .subscribe((res) => {
        console.log(res);
        this.plan = {
          idKalkulacija: res.data[0].idplanskakalkulacija,
          datum: moment(res.data[0].pp_datumsmjena).format('DD.MM.YYYY.'),
          sifra: res.data[0].ar_sifra,
          proizvod: res.data[0].ar_naziv,
          idProizvod: res.data[0].artikl_ar_id,
          linija: res.data[0].li_naziv,
          linijaId: res.data[0].pp_brojlinije,
          smjenaId: res.data[0].smjena_idsmjena,
          kolicina: res.data[0].pp_planiranakolicina,
          nedjelja: moment(res.data[0].pp_datumsmjena)
            .day(0)
            .format('YYYY-MM-DD'),
          petak: moment(res.data[0].pp_datumsmjena).day(5).format('YYYY-MM-DD'),
          rnId: res.data[0].nl_id === null ? '/' : res.data[0].nl_id,
          rnBroj: res.data[0].nl_broj === null ? '/' : res.data[0].nl_broj,
        };
        console.log(this.plan);
        this.cijenaStruja =
          res.data[0].pk_cijenaKW === null ? 0 : res.data[0].pk_cijenaKW;
        this.cijenaPlin =
          res.data[0].pk_cijenaplina === null ? 0 : res.data[0].pk_cijenaplina;
        this.cijenaVoda =
          res.data[0].pk_cijenavode === null ? 0 : res.data[0].pk_cijenavode;
        this.cijenaOTP =
          res.data[0].pk_otkKN === null ? 0 : res.data[0].pk_otkKN;
        this.napomena_komentar = res.data[0].pk_napomena;
        this.dohvatiTroskovnik(this.idPlan);
      });
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.tabs = [
      'Procesi',
      'Strojevi',
      'Normativi',
      'Djelatnici',
      'OTP',
      'Slike i komentar',
    ];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().planskaKalkulacija;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiProcese();
    this.dohvatiStrojeve();
    this.dohvatiSveDjelatnike();
    this.dohvatiSveProcese();
    this.dohvatiSveStrojeve();
  }

  updateTroskovnika() {
    this.service
      .updateTroskovnika({ idplanproizvodnje: this.idPlan })
      .subscribe((res) => {
        console.log(res);
      })
      .add(() => {
        this.dohvatiTroskovnik(this.idPlan);
      });
  }

  dohvatiTroskovnik(plan) {
    this.troskovnik = [];
    this.service
      .dohvatiTroskovnik({ idplanproizvodnje: plan })
      .subscribe((res) => {
        // console.log(res);
        this.troskovnik = res.data[0];
        console.log(this.troskovnik);
      });
  }

  dohvatiSveDjelatnike() {
    this.sviDjelatnici = [];
    this.service.dohvatiSveDjelatnike({}).subscribe((res) => {
      console.log(res);
      for (let data of res.data) {
        this.sviDjelatnici.push({
          ime: data.name,
        });
      }
      // console.log(this.sviDjelatnici);
    });
  }
  dohvatiSveProcese() {
    this.sviProcesi = [];
    this.service.dohvatiSveProcese({}).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        for (let data of res.data) {
          this.sviProcesi.push({
            id: data.idproces,
            ime: data.ps_naziv,
          });
        }
      }
      // console.log(this.sviProcesi);
    });
  }

  numberToHRK(number) {
    return new Intl.NumberFormat('hr-HR', {
      style: 'currency',
      currency: 'HRK',
    }).format(number);
  }

  dohvatiSveStrojeve() {
    this.sviStrojevi = [];
    this.service.dohvatiSveStrojeve({}).subscribe((res) => {
      console.log(res);
      for (let data of res.data) {
        this.sviStrojevi.push({
          id: data.idstroj,
          sifra: data.st_sifra,
          ime: data.st_naziv,
          sifraIme: data.st_sifra + ' ' + data.st_naziv,
        });
      }
      // console.log(this.sviProcesi);
    });
  }

  selectTab(e) {
    //console.log(e);
    if (e.itemIndex === 0) {
      this.dohvatiProcese();
      this.prikaziTablicuProcesi = true;
      this.prikaziTablicuStrojevi = false;
      this.prikaziTablicuNormativi = false;
      this.prikaziTablicuDjelatnici = false;
      this.prikaziTablicuOTP = false;
      this.prikaziTablicuNapomenaiSlike = false;
    }
    if (e.itemIndex === 1) {
      this.dohvatiStrojeve();
      this.prikaziTablicuProcesi = false;
      this.prikaziTablicuStrojevi = true;
      this.prikaziTablicuNormativi = false;
      this.prikaziTablicuDjelatnici = false;
      this.prikaziTablicuOTP = false;
      this.prikaziTablicuNapomenaiSlike = false;
    }
    if (e.itemIndex === 2) {
      this.dohvatiNormative();
      this.prikaziTablicuProcesi = false;
      this.prikaziTablicuStrojevi = false;
      this.prikaziTablicuNormativi = true;
      this.prikaziTablicuDjelatnici = false;
      this.prikaziTablicuOTP = false;
      this.prikaziTablicuNapomenaiSlike = false;
    }
    if (e.itemIndex === 3) {
      this.dohvatiDjelatnike();
      this.prikaziTablicuProcesi = false;
      this.prikaziTablicuStrojevi = false;
      this.prikaziTablicuNormativi = false;
      this.prikaziTablicuDjelatnici = true;
      this.prikaziTablicuOTP = false;
      this.prikaziTablicuNapomenaiSlike = false;
    }
    if (e.itemIndex === 4) {
      this.dohvatiOTP();
      this.prikaziTablicuProcesi = false;
      this.prikaziTablicuStrojevi = false;
      this.prikaziTablicuNormativi = false;
      this.prikaziTablicuDjelatnici = false;
      this.prikaziTablicuOTP = true;
      this.prikaziTablicuNapomenaiSlike = false;
    }
    if (e.itemIndex === 5) {
      this.prikaziTablicuProcesi = false;
      this.prikaziTablicuStrojevi = false;
      this.prikaziTablicuNormativi = false;
      this.prikaziTablicuDjelatnici = false;
      this.prikaziTablicuOTP = false;
      this.prikaziTablicuNapomenaiSlike = true;
      this.dohvatiDatoteke(this.idPlan, 'planskakalkulacija');
    }
  }

  dodajNapomenu(napomena) {
    console.log(napomena);
    let podaciZaSlanje = {
      idplanproizvodnje: this.idPlan,
      napomena: napomena,
    };
    console.log(podaciZaSlanje);
    this.service
      .dodajNapomenuPlanskakalkulacija(podaciZaSlanje)
      .subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          notify('Uspješno dodana napomena!', 'success', 3000);
        } else {
          notify('Dogodila se greška, pokušajte ponovno!', 'error', 3000);
        }
      });
  }

  clickFileUploader() {
    document.getElementById('kliknagumb').click();
  }

  fileChangeDoc(event) {
    //console.log(event)
    this.filee = event.target.files;
    //console.log(this.filee);
    this.uploadDoc();
  }

  uploadDoc() {
    //console.log('upload...');
    let fileList: FileList = this.filee;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('idfirma', localStorage.getItem('firma'));
      formData.append('idplanproizvodnje', this.idPlan);
      formData.append('datoteka', file);
      formData.append('nazivtablice', 'planskakalkulacija');
      this.service.datotekaUpload(formData).subscribe((res) => {
        //console.log(res);
        if (res.success == true) {
          notify('Uspješno ste dodali privitak...', 'success', 3000);
          this.dohvatiDatoteke(this.idPlan, 'planskakalkulacija');
        } else {
          notify(res.message, 'error', 3000);
        }
      });
    }
  }

  /*
  //devextreme dx-file-uploader
  uploadDoc(e){
    //console.log(e);
    let file = e.file;
    let formData: FormData = new FormData();
    formData.append('idfirma', localStorage.getItem('firma'));
    formData.append('idplanproizvodnje', this.idPlan);
    formData.append('datoteka', file);
    formData.append('nazivtablice', "planskakalkulacija");
    this.service.datotekaUpload(formData).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješno ste dodali privitak...', 'success', 3000);
        this.dohvatiDatoteke(this.idPlan, "planskakalkulacija");
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }
  */

  dohvatiDatoteke(idplanproizvodnje, nazivtablice) {
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        idplanproizvodnje: idplanproizvodnje,
        nazivtablice: nazivtablice,
      };
      console.log(podaciZaSlanje);
      this.isLoading = true;
      this.sviDokumenti = [];
      this.service.datotekaPopis(podaciZaSlanje).subscribe((res) => {
        console.log(res);
        if (res.success == true) {
          this.isLoading = false;
          //this.sviDokumenti = res.data;
          let brojac = 1;
          for (let data of res.data) {
            let arr = { ...data, redni_broj: brojac++ };
            this.sviDokumenti.push(arr);
          }
          console.log(this.sviDokumenti);
          resolve(1);
        } else {
          this.sviDokumenti = [];
          resolve(0);
        }
      });
    });
  }

  obrisiDokument(e: any) {
    console.log(e.data);
    this.service
      .datotekaObrisi({ iduploaddokument: e.data.iduploaddokument })
      .subscribe((res) => {
        console.log(res);
        if (res.success == true) {
          this.dohvatiDatoteke(this.idPlan, 'planskakalkulacija');
          notify('Uspješno ste obrisali dokument/e.', 'success', 3000);
        } else {
          notify('Došlo je do pogreške.', 'error', 3000);
        }
      });
  }

  // ==================================================
  // ========== TABLICA OTP
  // ==================================================
  dohvatiOTP() {
    this.ostaliTroskovi = [
      {
        id: 1,
      },
    ];
    this.isLoading = true;
    this.service
      .dohvatiOTP({ idplanproizvodnje: this.idPlan })
      .subscribe((res) => {
        console.log(res);
        this.ostaliTroskovi = [];
        if (res.success === true) {
          // this.ukupnaSumaOTP(this.idPlan);
          this.isLoading = false;
          for (let otp of res.data) {
            this.ostaliTroskovi.push({
              id: otp.idostalitroskoviproizvodnje,
              idProces: otp.proces_idproces,
              idStroj: otp.stroj_idstroj,
              ukupnoDodatak: otp.otp_ukupnododatak,
              ukupnoEkstraDodatak: otp.otp_ukupnoekstradodatak,
              naziv: otp.otp_nazivdodatka,
              cijena: otp.otp_cijenadodatkapomin,
              napomena: otp.otp_napomena,
            });
          }
          console.log(this.ostaliTroskovi);
        }
      });
  }

  urediOTP(data) {
    console.log(data);
    let podaci = {
      idostalitroskoviproizvodnje: data.data.id,
      idproces: data.data.idProces,
      idstroj: data.data.idStroj,
      nazivdodatka: data.data.naziv,
      cijenadodatkapomin: data.data.cijena,
      napomena: data.data.napomena,
      idplanproizvodnje: this.idPlan,
      otpumin: this.cijenaOTP,
    };
    console.log(podaci);
    this.service.urediOTP(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.updateTroskovnika();
        this.dohvatiOTP();
        // this.obracunaj();
        notify('Uspješna promjena podataka!', 'success', 3000);
      }
    });
  }

  dodajOTPPopup() {
    this.dodajOTPPopupVisible = true;
    this.odabraniProces = undefined;
    this.odabraniStroj = undefined;
    this.nazivDodatka = '';
    this.cijenaDodatka = null;
    this.napomena = '';
  }

  dodajOTP() {
    this.dodajOTPPopupVisible = false;
    let podaci = {
      idproces: this.odabraniProces,
      idstroj: this.odabraniStroj,
      nazivdodatka: this.nazivDodatka,
      cijenadodatkapomin: this.cijenaDodatka,
      napomena: this.napomena,
      idplanproizvodnje: this.idPlan,
      otpumin: this.cijenaOTP,
    };
    console.log(podaci);
    this.service.dodajOTP(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiOTP();
        this.updateTroskovnika();
        this.dodajOTPPopupVisible = false;
        notify('Uspješno dodavanje OTP!', 'success', 3000);
      }
    });
  }

  obrisiOTP(data) {
    console.log(data);
    this.service
      .obrisiOTP({ idostalitroskoviproizvodnje: data.data.id })
      .subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          this.dohvatiOTP();
          this.updateTroskovnika();
          notify('Uspješno brisanje.', 'success', 3000);
        }
      });
  }

  odaberiProcesOTP(e) {
    this.odabraniProces = e.value;
  }
  odaberiStrojOTP(e) {
    this.odabraniStroj = e.value;
  }
  onChangeNazivDodatka(e) {
    this.nazivDodatka = e.value;
  }
  onChangeCijenaDodatka(e) {
    this.cijenaDodatka = e.value;
  }

  // ==================================================

  // ==================================================
  // ========== TABLICA PROCESI
  // ==================================================
  dohvatiProcese() {
    this.isLoading = true;
    this.service
      .dohvatiProcese({ idplanproizvodnje: this.idPlan })
      .subscribe((res) => {
        console.log(res);
        this.procesi = [];
        if (res.success === true) {
          // this.ukupnaSumaProcesi(this.idPlan);
          this.isLoading = false;
          for (let proces of res.data) {
            this.procesi.push({
              id: proces.idppprocesi,
              idArtikl: proces.artikl_idartikl,
              idProces: proces.proces_idproces,
              rBroj: proces.pi_rednibroj_edit,
              naziv: proces.ps_naziv,
              vtoum: proces.pi_vrijemetrajanjaoperacije_edit,
              vtcpum: proces.pi_vrijemetrajanjacijelogprocesa_edit,
              vrrum: proces.pi_vrijemeradaradnika_edit,
              brno: proces.pi_brojradnikanaoperaciji_edit,
              vsrno: proces.pi_vrijemesvihradnikanaoperaciji_edit,
              crrum: proces.pi_cijenaradaradnika_edit,
              ucrpo: proces.pi_ukupnacijenaradapooperacijama_edit,
              aktivan: proces.pi_aktivan,
              napomena: proces.pi_napomena,
            });
          }
          console.log(this.procesi);
        }
      });
  }

  urediProces(data) {
    // console.log(data);
    let podaci = {
      idplanproizvodnje: this.idPlan,
      proces: data.data.idProces,
      idartikl: data.data.idArtikl,
      vrijemetrajanjaoperacije: data.data.vtoum,
      vrijemetrajanjacijelogprocesa: data.data.vtcpum,
      vrijemeradaradnika: data.data.vrrum,
      brojradnikanaoperaciji: data.data.brno,
      vrijemesvihradnikanaoperaciji: data.data.vsrno,
      cijenaradaradnika: data.data.crrum,
      ukupnacijenaradapooperacijama: data.data.ucrpo,
      rednibroj: data.data.rBroj,
      aktivan: data.data.aktivan,
      idppprocesi: data.data.id,
      napomena: data.data.napomena,
    };
    console.log(podaci);
    this.service.urediProces(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.updateTroskovnika();
        this.dohvatiProcese();
        this.obracunaj();
        notify('Uspješna promjena podataka!', 'success', 3000);
      }
    });
  }

  dodajProcesPopup() {
    this.dodajProcesPopupVisible = true;
    this.odabraniProces = undefined;
    this.vtoum = undefined;
    this.vtcpum = undefined;
    this.vrrum = undefined;
    this.brno = undefined;
    this.crrum = undefined;
    this.napomena = '';
  }

  odaberiProces(e) {
    // console.log(e);
    this.odabraniProces = e.value;
    if (this.odabraniProces) {
      this.service
        .dohvatiPredlozakProces({
          idplanproizvodnje: this.idPlan,
          idproces: this.odabraniProces,
        })
        .subscribe((res) => {
          console.log(res);
          if (res.success === true) {
            this.vtoum = res.data[0].pi_vrijemetrajanjaoperacije;
            this.vtcpum = res.data[0].pi_vrijemetrajanjacijelogprocesa;
            this.vrrum = res.data[0].pi_vrijemeradaradnika;
            this.brno = res.data[0].pi_brojradnikanaoperaciji;
            this.crrum = res.data[0].pi_cijenaradaradnika;
          }
        });
    }
  }

  onChangeVTOUM(e) {
    this.vtoum = e.value;
  }
  onChangeVTCPUM(e) {
    this.vtcpum = e.value;
  }
  onChangeVRRUM(e) {
    this.vrrum = e.value;
  }
  onChangeBRNO(e) {
    this.brno = e.value;
  }
  onChangeCRRUM(e) {
    this.crrum = e.value;
  }
  onChangeNapomena(e) {
    this.napomena = e.value;
  }

  dodajProces() {
    let podaci = {
      idplanproizvodnje: this.idPlan,
      proces: this.odabraniProces,
      idartikl: this.plan.idProizvod,
      rednibroj: '',
      vrijemesvihradnikanaoperaciji: '',
      ukupnacijenaradapooperacijama: '',
      vrijemetrajanjaoperacije: this.vtoum,
      vrijemetrajanjacijelogprocesa: this.vtcpum,
      vrijemeradaradnika: this.vrrum,
      brojradnikanaoperaciji: this.brno,
      cijenaradaradnika: this.crrum,
      napomena: this.napomena,
    };
    console.log(podaci);
    this.service.dodajProces(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiProcese();
        this.updateTroskovnika();
        this.dodajProcesPopupVisible = false;
        notify('Uspješno dodavanje procesa!', 'success', 3000);
      }
      if (res.message === 'Proces je već dodan na plan') {
        notify('Odabrani proces već postoji u planu!', 'warning', 3000);
      }
    });
  }
  // ==================================================

  // ==================================================
  // ========== TABLICA STROJEVI
  // ==================================================
  dohvatiStrojeve() {
    this.isLoading = true;
    this.service
      .dohvatiStrojeve({ idplanproizvodnje: this.idPlan })
      .subscribe((res) => {
        console.log(res);
        this.strojevi = [];
        if (res.success === true) {
          // this.ukupnaSumaStrojevi(this.idPlan);
          this.isLoading = false;
          for (let stroj of res.data) {
            this.strojevi.push({
              id: stroj.stroj_idstroj,
              idStroj: stroj.idppstroj,
              sifraStroj: stroj.st_sifra,
              naziv: stroj.st_naziv,
              aktivan: stroj.pis_aktivan,
              amortizacija: stroj.pis_amortizacija_edit,
              potrosnjaStruje: stroj.pis_potrosnjastrujenastroju_edit,
              struja: stroj.pis_ukupnastrujaukn,
              potrosnjaPlina: stroj.pis_potrosnjaplina_edit,
              plin: stroj.pis_ukupanplinukn,
              potrosnjaVode: stroj.pis_potrosnjavode_edit,
              voda: stroj.pis_ukupnovodaukn,
              ulaznaFaktura: stroj.pis_ulaznafaktura_edit,
              idProces: stroj.proces_idproces,
              napomena: stroj.pis_napomena,
            });
          }
        }
      });
  }

  urediStroj(data) {
    // console.log(data);
    let podaci = {
      idplanproizvodnje: this.idPlan,
      idartikl: this.plan.idProizvod,
      idlinija: this.plan.linijaId,
      amortizacija: data.data.amortizacija,
      potrosnjastrujenastroju: data.data.potrosnjaStruje,
      // strujastroj: data.data.struja,
      potrosnjaplina: data.data.potrosnjaPlina,
      // plinstroj: data.data.plin,
      potrosnjavode: data.data.potrosnjaVode,
      // vodastroj: data.data.voda,
      ulaznafaktura: data.data.ulaznaFaktura,
      aktivan: data.data.aktivan,
      idppstroj: data.data.idStroj,
      idstroj: data.data.id,
      idproces: data.data.idProces,
      napomena: data.data.napomena,
    };
    console.log(podaci);
    this.service.urediStroj(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.updateTroskovnika();
        this.dohvatiStrojeve();
        this.obracunaj();
        notify('Uspješna promjena podataka!', 'success', 3000);
      } else {
        this.dohvatiStrojeve();
        notify('Došlo je do greške!', 'error', 3000);
      }
    });
  }

  odaberiProcesStroj(e) {
    this.odabraniProces = e.value;
  }

  odaberiStroj(e) {
    this.odabraniStroj = e.value;
    if (this.odabraniStroj) {
      this.service
        .dohvatiPredlozakStroja({
          idplanproizvodnje: this.idPlan,
          idstroj: this.odabraniStroj,
        })
        .subscribe((res) => {
          console.log(res);
          if (res.success === true) {
            this.stroj = {
              amortizacija: res.data[0].pis_amortizacija,
              potrosnjaStruje: res.data[0].pis_potrosnjastrujenastroju,
              struja: res.data[0].pis_strujastroj,
              potrosnjaPlina: res.data[0].pis_potrosnjaplina,
              plin: res.data[0].pis_plinstroj,
              potrosnjaVode: res.data[0].pis_potrosnjavode,
              voda: res.data[0].pis_vodastroj,
              ulaznaFaktura: res.data[0].pis_ulaznafaktura,
            };
          }
        });
    }
  }
  onChangeAmortizacija(e) {
    this.stroj.amortizacija = e.value;
  }
  onChangePotrosnjaStruje(e) {
    this.stroj.potrosnjaStruje = e.value;
  }
  // onChangeStruja(e) {
  //   this.stroj.struja = e.value;
  // }
  onChangePotrosnjaPlina(e) {
    this.stroj.potrosnjaPlina = e.value;
  }
  // onChangePlin(e) {
  //   this.stroj.plin = e.value;
  // }
  onChangePotrosnjaVode(e) {
    this.stroj.potrosnjaVode = e.value;
  }
  // onChangeVoda(e) {
  //   this.stroj.voda = e.value;
  // }
  onChangeUlaznaFaktura(e) {
    this.stroj.ulaznaFaktura = e.value;
  }

  dodajStrojPopup() {
    this.dodajStrojPopupVisible = true;
    this.odabraniStroj = undefined;
    this.odabraniProces = undefined;
    this.stroj = {
      amortizacija: null,
      potrosnjaStruje: null,
      struja: null,
      potrosnjaPlina: null,
      plin: null,
      potrosnjaVode: null,
      voda: null,
      ulaznaFaktura: null,
    };
    this.napomena = '';
  }

  dodajStroj() {
    let podaci = {
      idplanproizvodnje: this.idPlan,
      idartikl: this.plan.idProizvod,
      idlinija: this.plan.linijaId,
      idstroj: this.odabraniStroj,
      amortizacija: this.stroj.amortizacija,
      potrosnjastrujenastroju: this.stroj.potrosnjaStruje,
      strujastroj: this.stroj.struja,
      potrosnjaplina: this.stroj.potrosnjaPlina,
      plinstroj: this.stroj.plin,
      potrosnjavode: this.stroj.potrosnjaVode,
      vodastroj: this.stroj.voda,
      ulaznafaktura: this.stroj.ulaznaFaktura,
      idproces: this.odabraniProces,
      napomena: this.napomena,
    };
    console.log(podaci);
    this.service.dodajStroj(podaci).subscribe((res) => {
      console.log(res);
      if (res.message === 'Proces je već dodan na plan') {
        notify('Odabrani stroj već postoji u planu!', 'warning', 3000);
      } else if (res.message === 'Uspješno') {
        this.dohvatiStrojeve();
        this.updateTroskovnika();
        this.dodajStrojPopupVisible = false;
        notify('Uspješno dodan stroj!', 'success', 3000);
      } else {
        this.dohvatiStrojeve();
        notify('Došlo je do greške!', 'error', 3000);
      }
    });
  }

  dohvatiNormative() {
    this.isLoading = true;
    this.service
      .dohvatiNormative({
        idplanproizvodnje: this.idPlan,
        idartikl: this.plan.idProizvod,
        idfirma: localStorage.getItem('firma'),
      })
      .subscribe((res) => {
        console.log(res);
        this.normativi = [];
        if (res.success === true) {
          // this.ukupnaSumaNormativi(this.idPlan, this.plan.idProizvod);
          this.isLoading = false;
          for (let normativ of res.data) {
            this.normativi.push({
              id: normativ.ns_id,
              sifra: normativ.sifranormativstavki,
              naziv: normativ.normativstavske,
              kolicina: normativ.kolicinaneto,
              cijena: normativ.za_zadnabcij,
              ukupnaCijena: normativ.ukupnacijena,
              ukupnaCijenaPrikaz: this.numberToHRK(normativ.ukupnacijena).slice(0,-3),
              jedinicaMjere: normativ.jedinicamjere_JM_SIFRA,
              ukupnaKolicina: normativ.kolicinaiplansuma,
              ukupnoUtrosenaKolicina: normativ.kolicinaiplansuma_edit,
            });
          }
        }
      });
  }

  urediNormativ(e: any) {
    console.log(e);
    let data = {
      idppnormativstavke: e.data.id,
      kolicinaodstupanja: e.data.ukupnaKolicina,
      operater: localStorage.getItem('user'),
    };
    console.log(data);
    this.service.urediNormativ(data).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.updateTroskovnika();
        notify('Uspješna promjena podataka!', 'success', 3000);
        this.dohvatiNormative();
      } else {
        notify('Dogodila se greška, pokušajte ponovno!', 'error', 3000);
      }
    });
  }

  dohvatiDjelatnike() {
    this.isLoading = true;
    this.service
      .dohvatiDjelatnike({ idplanproizvodnje: this.idPlan })
      .subscribe((res) => {
        console.log(res);
        this.djelatnici = [];
        if (res.success === true) {
          this.isLoading = false;
          for (let djelatnik of res.data) {
            this.djelatnici.push({
              id: djelatnik.idppdjelatnikplan,
              aktivan: djelatnik.dp_aktivan,
              ime: djelatnik.dp_djelatnik,
              pocetak: djelatnik.dp_vrijemeod.slice(0, -3),
              kraj: djelatnik.dp_vrijemedo.slice(0, -3),
              vrijemeRada: djelatnik.vrijemerada.slice(0, -3),
              napomena: djelatnik.dp_napomena,
            });
          }
          console.log(this.djelatnici);
        }
      });
  }

  urediDjelatnika(data) {
    console.log(data);
    let podaci = {
      idplanproizvodnje: this.idPlan,
      idppdjelatnikplan: data.data.id,
      djelatnik: data.data.ime,
      vrijemeod: data.data.pocetak,
      vrijemedo: data.data.kraj,
      aktivan: data.data.aktivan,
      napomena: data.data.napomena,
    };
    console.log(podaci);
    this.service.urediDjelatnika(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiDjelatnike();
        notify('Uspješna promjena podataka!', 'success', 3000);
      } else {
        this.dohvatiDjelatnike();
        notify('Došlo je do greške!', 'error', 3000);
      }
    });
  }

  dodajDjelatnikaPopup() {
    this.dodajDjelatnikaPopupVisible = true;
    this.odabraniDjelatnik = undefined;
    if (this.plan.smjenaId == '1') {
      this.pocetak = moment('00:00', 'HH:mm').add(6, 'hours').toISOString(true);
      this.kraj = moment('00:00', 'HH:mm').add(14, 'hours').toISOString(true);
    } else if (this.plan.smjenaId == '2') {
      this.pocetak = moment('00:00', 'HH:mm')
        .add(14, 'hours')
        .toISOString(true);
      this.kraj = moment('00:00', 'HH:mm').add(22, 'hours').toISOString(true);
    } else if (this.plan.smjenaId == '3') {
      this.pocetak = moment('00:00', 'HH:mm')
        .add(22, 'hours')
        .toISOString(true);
      this.kraj = moment('00:00', 'HH:mm').add(6, 'hours').toISOString(true);
    }
    this.napomena = '';
  }

  odaberiDjelatnika(e) {
    // console.log(e);
    this.odabraniDjelatnik = e.value;
  }

  promjeniPocetak(e) {
    // console.log(e);
    this.pocetakSlanje = moment(e.value).format('HH:mm:ss');
  }

  promjeniKraj(e) {
    // console.log(e);
    this.krajSlanje = moment(e.value).format('HH:mm:ss');
  }

  dodajDjelatnika() {
    let podaci = {
      idplanproizvodnje: this.idPlan,
      djelatnik: this.odabraniDjelatnik,
      vrijemeod: this.pocetakSlanje,
      vrijemedo: this.krajSlanje,
      napomena: this.napomena,
    };
    console.log(podaci);
    this.service.dodajDjelatnika(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiDjelatnike();
        this.dodajDjelatnikaPopupVisible = false;
        notify('Uspješna dodavanje!', 'success', 3000);
      }
    });
  }

  toggleStatus(data) {
    // console.log(data);
    this.oznacenRed = data.rowIndex;
    let aktivan = data.data.aktivan ? 0 : 1;
    this.dataGrid.instance.cellValue(this.oznacenRed, 'aktivan', aktivan);
  }

  obracunaj() {
    let podaci = {
      idplanproizvodnje: this.idPlan,
      idplanskakalkulacija: this.plan.idKalkulacija,
      idartikl: this.plan.idProizvod,
      artiklsifra: this.plan.sifra,
      brojkomada: this.plan.kolicina,
      idlinija: this.plan.linijaId,
      cijenaKW: this.cijenaStruja,
      cijenaplina: this.cijenaPlin,
      cijenavode: this.cijenaVoda,
      otkKN: this.cijenaOTP,
    };
    console.log(podaci);
    this.service.obracunajKalkulaciju(podaci).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiStrojeve();
        this.dohvatiOTP();
        // this.ukupnoSuma();
        this.updateTroskovnika();
        notify('Uspješno uređivanje!', 'success', 3000);
      }
    });
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      // {
      //   location: 'before',
      //   template: 'naslovTablice',
      // },
      {
        location: 'after',
        template: 'headerRight',
      }
    );
  }

  onEditorPreparing(e) {
    this.maskRules = {
      H: (char) => char >= 0 && char <= 2,
      h: (char, index, fullStr) => {
        if (fullStr[0] == '2') return [0, 1, 2, 3].includes(parseInt(char));
        else return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(char));
      },
      M: (char) => char >= 0 && char <= 5,
      m: (char) => char >= 0 && char <= 9,
    };
    // console.log(e);
    if (e.dataField === 'pocetak' || e.dataField === 'kraj') {
      e.editorOptions.mask = 'Hh:Mm';
      e.editorOptions.maskRules = this.maskRules;
      e.editorOptions.useMaskedValue = true;
    }
  }

  onCellPreparedStrojevi(options) {
    // console.log(options);
    if (
      options.rowType == 'data' &&
      (options.columnIndex == 4 ||
        options.columnIndex == 6 ||
        options.columnIndex == 8)
    ) {
      options.cellElement.classList.add('notEditable');
    }
  }

  onCellPreparedProcesi(options) {
    // console.log(options);
    if (
      options.rowType == 'data' &&
      (options.columnIndex == 6 || options.columnIndex == 8)
    ) {
      options.cellElement.classList.add('notEditable');
    }
  }

  onCellPreparedOTP(options) {
    // console.log(options);
    if (
      options.rowType == 'data' &&
      (options.columnIndex == 3 || options.columnIndex == 5)
    ) {
      options.cellElement.classList.add('notEditable');
    }
  }

  // changeBgColor() {
  //   setInterval(function() {
  //     let n1 = Math.floor(Math.random() * (255 - 0 + 1) + 0);
  //     let n2 = Math.floor(Math.random() * (255 - 0 + 1) + 0);
  //     let n3 = Math.floor(Math.random() * (255 - 0 + 1) + 0);
  //     this.bgColor = "rgb("+n1+","+n2+","+n3+")";
  //     document.getElementById("card").style.backgroundColor = this.bgColor;
  //   }, 100);
  // }
}
